import { Component, OnInit } from '@angular/core';
import {Subscription} from "rxjs";
import {Setting} from "../_models/setting";
import {SettingsStoreService} from "../_services/settings-store.service";
import {ApiRestService} from "../_services/api-rest.service";
import {Categorie} from "../../Progetti/Models/Categorie";
import {ActivatedRoute, Router} from "@angular/router";
import {hsl} from "d3";

@Component({
  selector: 'app-settings-categorie',
  templateUrl: './settings-categorie.component.html',
  styleUrls: ["Settings-Categorie.component.scss"]
})
export class SettingsCategorieComponent implements OnInit {
  subscriptions: Subscription = new Subscription();
  Settings: Setting[] = [];
  sel_cat_id: string = null;
  type: string = "";
  constructor(
    private settingsStore: SettingsStoreService,
    private apiRestService: ApiRestService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.settingsStore.GetListaSettings();
    this.subscriptions.add(this.settingsStore.$settings.subscribe(data => {
      this.Settings = data;
      if(data && data.length >0 && data[0])
        this.clicked(data[0]);
    }));
    this.route.params.subscribe(data => {
      this.type = data['type'];
      this.sel_cat_id = this.type;
      console.log(this.type)
      // if(this.type == "refresh" && this.Settings && this.Settings.length >0 && this.Settings[0])
      //   this.clicked(this.Settings[0]);
    })
  }
  clicked(cat: Setting){
    if(cat && cat.id){
      this.sel_cat_id = cat.id;
      console.log(this.sel_cat_id)
      this.router.navigate([this.route.snapshot.queryParams[`settings/settings/lista/${cat.id}`] || `settings/settings/lista/${cat.id}`,]);
    }
  }
  BG_Color(val: boolean){
    if(!val)
      return hsl(0, 0, 0,0);
    return hsl(0, 0, 0, 0.1);
  }
}
